import { generateRoute } from '@klp/routing';

export const FileModuleName = 'file';
const kundeportalModuleName = 'kundeportal';

export const FileRoutes = {
    preview: (path: string, fileId: number | string) =>
        generateRoute([
            kundeportalModuleName,
            FileModuleName,
            encodeURIComponent(path),
            fileId,
        ]),
};
